import React from 'react';
import Modal from '../../component/Inc/Modal';
function PopManageReservation(props) {
  const {open, close} = props;
  return (
    <Modal open={open} close={close} type="com_input pop_manage_reservation">
      <h2 className="pop_tit">강의실 예약</h2>
      <div className="content_container scroll">
        <ul className="com_input_sec">
          <li className="tit_field">강의실 선택</li>
          <li>
            <input type="text" className="input" />
          </li>
          <li className="tit_field">날짜</li>
          <li>
            <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
          </li>
          <li className="tit_field">시작 시간</li>
          <li>
            <select className="select">
              <option value="선택">선택</option>
            </select>
          </li>
          <li className="tit_field">필요한 시간</li>
          <li>
            <select className="select">
              <option value=" 필요한 시간 입력"> 필요한 시간 입력</option>
            </select>
          </li>
          <li className="tit_field">분류</li>
          <li>
            <select className="select">
              <option value="면접">면접</option>
            </select>
          </li>
          <li className="tit_field">예약자</li>
          <li>
            <select className="select">
              <option value="학생명&교사, 지원명">학생명&교사, 지원명</option>
            </select>
          </li>
          <li className="tit_field">반복 예약</li>
          <li>
            <select className="select">
              <option value="1개월">1개월</option>
            </select>
          </li>
          <li className="tit_field">내용</li>
          <li>
            <textarea name="" id="" placeholder="예약 내용 입력"></textarea>
          </li>
        </ul>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">예약</button>
      </div>
      {/* <div className="btn_container">
        <button className="com_btn orange xs">저장</button>
        <button className="com_btn black xs">예약 삭제</button>
      </div> */}
    </Modal>
  );
}

export default PopManageReservation;
